import { z } from 'zod'

export const CONNECT_INTEREST_OPTIONS = ['engage-market-maker', 'treasury-management', 'other'] as const

export const CONNECT_TOKEN_STATUS_OPTIONS = ['pre-tge', 'listed', 'no-token'] as const

export const ConnectRequestBodySchema = z
  .object({
    interest: z.enum(CONNECT_INTEREST_OPTIONS),
    tokenStatus: z.enum(CONNECT_TOKEN_STATUS_OPTIONS),
    coingeckoId: z.string().trim().min(1).max(100).optional(),
    projectName: z.string().trim().min(1).max(200).optional(),
    tokenTicker: z.string().trim().min(1).max(20).optional(),
    fullName: z.string().trim().min(1).max(200),
    email: z.string().email().max(320),
    turnstileToken: z.string().optional(),
  })
  .strict()
  .superRefine((value, ctx) => {
    if (value.tokenStatus !== 'no-token') {
      if (!value.projectName) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['projectName'],
          message: 'Project name is required',
        })
      }
      if (!value.tokenTicker) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['tokenTicker'],
          message: 'Token ticker is required',
        })
      }
    }
  })

export type ConnectRequestBodyType = z.infer<typeof ConnectRequestBodySchema>
export type ConnectInterestType = (typeof CONNECT_INTEREST_OPTIONS)[number]
export type ConnectTokenStatusType = (typeof CONNECT_TOKEN_STATUS_OPTIONS)[number]
